import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/checklistItems/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_COMPLETED = NAMESPACE + 'SET_COMPLETED'

const defaultCardState = {}

const initialState = {}

const checklistItemDefaults = {
  name: '',
  completed: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case ADD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          [action.payload.checklistItem.id]: {
            ...checklistItemDefaults,
            ...action.payload.checklistItem,
          }
        }
      } : undefined
    case ADD_ARRAY: {
      if (!state[action.payload.cardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId]
        }
      }

      action.payload.array.forEach(checklistItem => {
        newState[action.payload.cardId][checklistItem.id] = {
          ...checklistItem
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.cardId] || !state[action.payload.cardId][action.payload.checklistItemId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId]
        }
      }

      delete newState[action.payload.cardId][action.payload.checklistItemId]

      return newState
    }
    case SET_NAME:
      return (state[action.payload.cardId] && state[action.payload.cardId][action.payload.checklistItemId]) ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          [action.payload.checklistItemId]: {
            ...state[action.payload.cardId][action.payload.checklistItemId],
            name: action.payload.name
          }
        }
      } : state
    case SET_COMPLETED:
      return (state[action.payload.cardId] && state[action.payload.cardId][action.payload.checklistItemId]) ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          [action.payload.checklistItemId]: {
            ...state[action.payload.cardId][action.payload.checklistItemId],
            completed: action.payload.completed
          }
        }
      } : state
    default: return state
  }
}

export function add ({ cardId, checklistItem }) {
  return {
    type: ADD,
    payload: {
      cardId,
      checklistItem,
    }
  }
}

export function addArray ({ cardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardId,
      array
    }
  }
}

export function remove ({ cardId, checklistItemId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      checklistItemId
    }
  }
}

export function setName ({ cardId, checklistItemId, name }) {
  return {
    type: SET_NAME,
    payload: {
      cardId,
      checklistItemId,
      name
    }
  }
}

export function setCompleted ({ cardId, checklistItemId, completed }) {
  return {
    type: SET_COMPLETED,
    payload: {
      cardId,
      checklistItemId,
      completed
    }
  }
}
